import { LOCALES } from '../lang';
import HelperService from '../services/HelperService';
import MockUpService from '../services/MockUpService';
import store from '../store';
import { appSlice, localizationSlice } from '../store/slices';

const TelegramWebApiService = {
	TelegramWebApi: {},
	Init: () => {
		if (!window.Telegram.WebApp.initData) {
			window.Telegram.WebApp = MockUpService?.TelegramWebApi?.WebApp || {};
			TelegramWebApiService.TelegramWebApi = window.Telegram.WebApp;
			console.log('The app is running in regular browser (not in Telegram)');
			return;
		}
		TelegramWebApiService.TelegramWebApi = window?.Telegram?.WebApp;
		store.dispatch(appSlice.actions.setisItTelegram(true));
		console.log(TelegramWebApiService?.TelegramWebApi);
		return;
	},
	Ready: () => {
		TelegramWebApiService?.TelegramWebApi?.ready();
	},
	Expand: () => {
		TelegramWebApiService?.TelegramWebApi?.expand();
	},
	Close: () => {
		TelegramWebApiService?.TelegramWebApi?.close();
	},
	GetCloudStorage: () => {
		return TelegramWebApiService?.TelegramWebApi?.CloudStorage;
	},
	ShowAlert: (message = '', callback = () => {}) => {
		TelegramWebApiService?.TelegramWebApi?.showAlert(message, callback);
	},
	InitTheme: () => {
		const currentTheme = store.getState()?.app?.theme;
		const settingsTheme = TelegramWebApiService?.TelegramWebApi?.colorScheme;
		if (currentTheme === settingsTheme) return;
		store.dispatch(appSlice?.actions?.setTheme(settingsTheme));
	},
	HandleThemeChange: () => {
		// TelegramWebApiService?.ShowAlert('themeChanged');
		TelegramWebApiService?.InitTheme();
	},
	OnThemeChange: () => {
		TelegramWebApiService?.TelegramWebApi?.onEvent('themeChanged', TelegramWebApiService.HandleThemeChange);
	},
	OffThemeChange: () => {
		TelegramWebApiService?.TelegramWebApi?.offEvent('themeChanged', TelegramWebApiService.HandleThemeChange);
	},
	SetLanguage: () => {
		const currentLang = store.getState()?.localization?.lang;
		const settingsLang = store.getState()?.app?.isItTelegram
			? TelegramWebApiService?.TelegramWebApi?.initDataUnsafe?.user?.language_code
			: localStorage.getItem('lang') || HelperService.detectPWALanguage();
		const lang = Object?.values(LOCALES)?.some(l => l === settingsLang)
			? settingsLang
			: HelperService.detectPWALanguage();
		if (currentLang === lang) return;
		store.dispatch(localizationSlice?.actions?.setLanguage(lang));
	},
	LockOrientationLandscape: () => {
		TelegramWebApiService?.TelegramWebApi?.lockOrientation('landscape');
	},
	DisableVerticalSwipes: () => {
		TelegramWebApiService?.TelegramWebApi?.disableVerticalSwipes();
	},
	RequestFullscreen: () => {
		TelegramWebApiService?.TelegramWebApi?.requestFullscreen();
	},
	InitHeader: () => {
		TelegramWebApiService?.TelegramWebApi?.setHeaderColor('#ffffff');
		TelegramWebApiService?.TelegramWebApi?.setBackgroundColor('#ffffff');
	},
};
export default TelegramWebApiService;
